/* React */
import React from "react";

/* Components */
import ChartWrapper from "src/utils/wrapper/chart-wrapper/ChartWrapper";
import StackedHistogram from "src/components/charts/stacked-histogram/StackedHistogram";
import VerticalBoxplot from "src/components/charts/vertical-boxplot/VerticalBoxplot";
import StatsContainer from "src/components/charts/vertical-boxplot/stats-container/StatsContainer";

/* Utils*/
import { ChartType } from "src/shared/constants/charts/Chart";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { DescriptiveStatisticsProps } from "src/shared/interfaces/DescriptiveStatistics";
import { SurvivalAnalysisProps } from "src/shared/interfaces/SurvivalAnalysis";

export const createHistogram = (
  index: number,
  label: React.ReactNode,
  data: BaseChartProps<
    DescriptiveStatisticsProps | SurvivalAnalysisProps,
    ChartType[]
  >,
  legend: React.ReactNode,
  downloadFilename?: string
) => {
  return [
    {
      component: (
        <ChartWrapper
          label={label}
          legend={legend}
          downloadFilename={downloadFilename}
        >
          {(height, width) => (
            <StackedHistogram
              key={`histogram-${index}`}
              data={data.data[ChartType.HISTOGRAM]}
              dimensions={{ height, width }}
            />
          )}
        </ChartWrapper>
      ),
      fullWidth: true,
    },
    {
      component: (
        <ChartWrapper
          legend={legend}
          downloadFilename={
            downloadFilename
              ? `${downloadFilename}-boxplot`
              : undefined
          }
        >
          {(height, width) => (
            <VerticalBoxplot
              key={`boxplot-${index}`}
              data={data.data[ChartType.BOX]}
              dimensions={{ height, width }}
            />
          )}
        </ChartWrapper>
      ),
      size: "9",
    },
    {
      component: (
        <ChartWrapper
          scssProps={{
            padding: "0px",
            height: "99%",
          }}
        >
          {() => (
            <StatsContainer
              key={`stats-${index}`}
              data={data.data[ChartType.BOX]}
            />
          )}
        </ChartWrapper>
      ),
      size: "3",
    },
  ];
};
